import { useMemo } from "react";
import { useNotification } from "../../../../../hooks/useNotification";
import { useCancelConsignmentsMutation } from "../../../../../store/apiSlice/shipmentApiSlice";
import { AddToShipmentCss, DetailsOfOrderCss } from "../../Allocation/AddToShipment";
import { BlurModal } from "../BlurModal/BlurModal";
import { Button } from "../Button/Button";
import { ModalHeader } from "../PurchaseOrderDetails/TrackingStatus";
import styled from "styled-components";

export const CancelShipmentModal = ({ closeModal, ordersName, setSelectedOrder }) => {
  const [cancelShipment] = useCancelConsignmentsMutation();

  const notify = useNotification();

  const handleSubmit = async () => {
    if (ordersName?.length === 0) return;
    try {
      const res = await cancelShipment({ ids: ordersName.map(order => order.id) });

      let type = "success";
      let message = "Success! Your shipment is now cancelled.";
      if (res.error) {
        type = "error";
        message = res.error.data?.ids[0];
      }

      notify({ type, message, position: "top-center" });
      setSelectedOrder([]);
      closeModal();
    } catch (error) {
      if (error.data?.detail) {
        notify({ type: "error", message: error.data.detail, position: "top-center" });
      }
    }
  };

  const isDisabledBtn = ordersName.find(
    order => order.status === "Full Receipt Created" || order.status === "Cancelled",
  );

  return (
    <BlurModal>
      <AddToShipmentCss>
        <ModalHeader headerName="Cancel Shipment" closeModal={closeModal} />
        <DetailsOfOrder
          ordersName={ordersName}
          headerForOrder={"You're about to cancel a shipment. Are you sure?"}
        />

        <Button
          isDisabledButton={isDisabledBtn}
          btnName="Submit"
          handler={() => handleSubmit()}
          classOfBtn="submitBtn"
        />
      </AddToShipmentCss>
    </BlurModal>
  );
};

const DetailsOfOrder = ({ ordersName, headerForOrder }) => {
  const filteredOrder = useMemo(() => {
    let data = { cancellable: [], notCancellable: [] };
    ordersName.forEach(item => {
      if (item.status === "Full Receipt Created" || item.status === "Cancelled") {
        data.notCancellable.push(item);
      } else {
        data.cancellable.push(item);
      }
    });
    return data;
  }, [ordersName]);

  return (
    <DetailsOfOrderCss>
      <p>{headerForOrder}</p>
      <ul>
        {filteredOrder.cancellable.length > 0 &&
          filteredOrder.cancellable.map(order => <li key={order.name}>{order.name} </li>)}
      </ul>
      {filteredOrder.notCancellable.length > 0 && (
        <>
          <NotAllowed>
            Oops! Following shipments couldn't be cancelled because of their status.
          </NotAllowed>
          <ul>
            {filteredOrder.notCancellable.map(order => (
              <li>{order.name} </li>
            ))}
          </ul>
        </>
      )}
    </DetailsOfOrderCss>
  );
};

export const NotAllowed = styled.div`
  color: var(--DANGER, #cf324a);
`;
